import "./report.css";
import * as React from "react";
import { RootState } from "../../../core/reducers";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { IconsItem } from "./postureMuscle";
import muscleFront from "../../../assets/posture/muscle/muscleFront.png";
import muscleSide from "../../../assets/posture/muscle/muscleSide.png";
import muscleBack from "../../../assets/posture/muscle/muscleBack.png";
import { FormattedMessage } from "react-intl";
import hightRiskIcon from "../../../assets/reportIcon/hightRiskIcon.png";
import middleRiskIcon from "../../../assets/reportIcon/middleRiskIcon.png";
import goodIcon from "../../../assets/reportIcon/goodIcon.png";
import { drawMuscle, muscle_sideArg, muscle_frontArg, muscle_backArg } from "./muscleNew";
import { ReportData } from "../../../core/actions/institution";
import { GetMuscleStateResponse_DiseaseMuscleResult as DiseaseMuscleResult, GetMuscleStateResponse_Status as Status } from "../../../api/algorithm/posture/posture";

export interface ReportStateProps {
  frontRisks: Array<IconsItem>;
  sideRisks: Array<IconsItem>;
  backRisks: Array<IconsItem>;
  reportPageData: ReportData;
}
export interface ReportDispatchProps {}
export interface ReportProps {
  reportPageData: ReportData;
}
class Report extends React.Component<ReportProps & ReportDispatchProps, ReportStateProps> {
  state: ReportStateProps = {
    reportPageData: Object.assign({ doctorName: "" }),
    frontRisks: [],
    sideRisks: [],
    backRisks: [],
  };
  componentWillReceiveProps(props) {
    let reportPageData: ReportData = props.reportPageData;
    this.draw(reportPageData);
    this.setState({
      reportPageData,
    });
  }

  draw = async (reportPageData: ReportData) => {
    let muscleStateResults = reportPageData.muscleStateResults;
    if (!muscleStateResults) {
      return;
    }

    let diseaseArr: DiseaseMuscleResult[] = [];
    muscleStateResults.map((item) => {
      if (item.diseaseMuscleResults.length) {
        diseaseArr = [...diseaseArr, ...item.diseaseMuscleResults];
      }
    });

    let frontlist = this.drawData(diseaseArr, muscle_frontArg, muscleFront, "muscleFront");
    let sidelist = this.drawData(diseaseArr, muscle_sideArg, muscleSide, "muscleSide");
    let backlist = this.drawData(diseaseArr, muscle_backArg, muscleBack, "muscleBack");

    this.setState({
      frontRisks: frontlist,
      sideRisks: sidelist,
      backRisks: backlist,
    });
  };

  drawData = (diseaseArr, muscle, url, canvasId) => {
    let list: any[] = [];
    let data: any[] = [];
    muscle.map((item) => {
      let obj =
        diseaseArr.filter((d) => {
          return d.muscleResult.muscleKey === item.key && Status[d.status] == Status[item.status];
        })[0] || {};
      if (obj.detailId) {
        let sa =
          list.filter((s) => {
            return obj.diseaseMuscleId === s.diseaseMuscleId;
          })[0] || {};
        !sa.detailId && list.push(obj);
        data.push(item);
      }
    });
    drawMuscle(url, data, canvasId);
    return list;
  };

  render() {
    let muscleList = [
      {
        key: "muscleFront",
        direction: <FormattedMessage id="front"></FormattedMessage>,
        riskList: this.state.frontRisks,
      },
      {
        key: "muscleSide",
        direction: <FormattedMessage id="side"></FormattedMessage>,
        riskList: this.state.sideRisks,
      },
      {
        key: "muscleBack",
        direction: <FormattedMessage id="back"></FormattedMessage>,
        riskList: this.state.backRisks,
      },
    ];
    return (
      <div className="muscleStatus">
        <div className="appDataHead">
          <div className="appDataRect"></div>
          <div className="appDataText">
            <FormattedMessage id="muscleState" />
          </div>
        </div>
        <div className="muscleStatusCanvas">
          {muscleList.map((item) => {
            return (
              <div key={item.key} className="muscleCanvasItem">
                <div className="muscleCanvasAndRisk">
                  <canvas id={item.key} className="muscleCanvas"></canvas>
                  <div className="mucleRiskList">
                    {item.riskList.map((r: any, index) => {
                      return (
                        <div key={index} className={"muscleRiskItem risk" + r.status}>
                          <span className="muscleRiskText">{r.description}</span>
                          <img
                            src={r.status == "Tension" ? hightRiskIcon : middleRiskIcon}
                            className={"muscleRiskIcon icon" + r.status}
                          ></img>
                        </div>
                      );
                    })}
                    {item.riskList.length == 0 && (
                      <div className="goodBody">
                        <img className="goodIcon" src={goodIcon} />
                        <div className="goodIconText">
                          <FormattedMessage id="muscleStateDesc" />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="muscleDirection">{item.direction}</div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state: RootState): ReportProps {
  return {
    reportPageData: state.institution.reportPageData,
  };
}
function mapDispatchToProps(dispatch: ThunkDispatch<RootState, null, AnyAction>): ReportDispatchProps {
  return {};
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Report) as any);
